module.exports = __webpack_public_path__ + "static/media/account_list.236c2323.svg";